/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';

export default function store() {
    return {
        boundarywaters: {
            permitType: null,
            permitDate: gnoment().tz('America/Chicago').format(),
            activeTab: 0,
            divisionSearchCriteria: {
                searchText: '',
                areas: [],
                motorSize: null,
                canadianAccess: null,
            },
            questionnaire: {
                motorSpendNightOnWayToCanada: null,
                motorSpendNightOnWayFromCanada: null,
                paddleSpendNightOnWayToCanada: null,
                paddleSpendNightOnWayFromCanada: null,
            },
            selectedDivision: null,
            selectedStartDate: null,
            selectedEndDate: null,
            selectedDivision2: null,
            selectedStartDate2: null,
            selectedEndDate2: null,
            issuanceLoading: false,
            permit: {
                result: {
                    divisions: {},
                    equipments: [],
                    validations: [],
                },
                divisions: [],
                recareas: [],
                recarea: [],
                availabilities: {},
                cooperators: [],
                cooperator: null,
                issuance: {},
                order_confirmation: {
                    completedReservations: [],
                },
            },
            validation: {
                summary: [],
            },
            divisionDetailsModal: {
                isOpen: false,
                divisionId: '',
            },
        },
    };
}
